import { SoldOutBadge, SoldOutOverlayContainer, SoldOutTitle } from './styles'

/**
 * 재고 소진 딤 오버레이 (Figma Growth 257-2619).
 *
 * 재고가 모두 소진된 경우 랜딩 위에 덮어 "SOLD OUT" 배지 + 안내 문구를 노출한다.
 * 하단 CTA 바는 더 높은 z-index 로 이 위에 노출되어 비활성 안내 문구를 보여준다.
 */
export function SoldOutOverlay() {
  return (
    <SoldOutOverlayContainer>
      <SoldOutBadge>SOLD OUT</SoldOutBadge>
      <SoldOutTitle>준비된 수량이{'\n'}모두 품절되었어요</SoldOutTitle>
    </SoldOutOverlayContainer>
  )
}
